import { Loader2 } from 'lucide-react'

interface SpinnerProps {
  size?: 'xs' | 'sm' | 'md'
  className?: string
}

const sizeMap = { xs: 'h-3 w-3', sm: 'h-4 w-4', md: 'h-5 w-5' }

export function Spinner({ size = 'sm', className = '' }: SpinnerProps) {
  return <Loader2 className={`animate-spin ${sizeMap[size]} ${className}`} />
}
